/* eslint-disable no-useless-escape */
import _ from "lodash";
import $ from "jquery";
import { BroadcastChannel } from "broadcast-channel";
import Moment from "moment";
import momentTimezone from "moment-timezone";
import {
  finwellSteps,
  getFinwellSteps,
  joyRideGuestSteps,
  joyRideGuestStepsPremium,
  joyRideSteps,
  joyRideStepsManager,
  joyRideStepsManagerPremium,
  joyRideStepsPremium,
} from "./joyRideJsonScript";
import { extendMoment } from "moment-range";
import CryptoJS from "crypto-js";
import {
  getAssignBrokerCourse,
  getAssignCourse,
  getCheckListInsert,
  getForYouData,
  getProductCategoriesData,
  markModuleProgress,
} from "../redux/courses/actions";
import CONFIG from "./config";
import { setJoyRideReq } from "../redux/assignCourse/actions";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import axios from "axios";
import { getLoginLogo, setIsLoadingGlobal } from "../redux/home/actions";
import { useNavigate as navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { store } from "../redux/store";
import API_LIST from "./apiList";
import { getNonMyOBLPListing } from "../redux/learningPath/actions";

const moment = extendMoment(Moment);
export const LOGIN_CHANNEL = new BroadcastChannel("login");

export const showToast = (message, type = "success") => {
  console.log("showToast called with:", message, type);
  window.dispatchEvent(
    new CustomEvent("showToast", {
      detail: { message, type },
    }),
  );
};

export const emailValidation = (emailStr) => {
  const regex =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  if (!emailStr || regex.test(emailStr) === false) {
    return false;
  }
  return true;
};

export const cnfPwdValidation = (pass, cnfPwd) => {
  if (pass === null || pass === undefined || pass === "" || pass !== cnfPwd) {
    return false;
  }
  return true;
};

export const passLimitValidation = (pass) => {
  if (pass === null || pass === undefined || pass.length < 6) {
    return false;
  }
  return true;
};

export const passCharValidation = (password) => {
  var regularExpression =
    /^(?=.*[A-Z])(?=.*[0-9])(?=.*[~`!@#$%^&*()-_+={}[]|\/:;"'<>,.?])[a-zA-Z0-9~`!@#$%^&*()-_+={}[]|\/:;"'<>,.?]{6,}$/;
  return regularExpression.test(password);
};

export const forYouOnSuccessBookMark = (dispatch) => {
  let reqObj = {
    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    category_id: [],
    search: "",
    page_size: 100,
    page: 1,
    asset_id: [],
    pillar_id: "",
    is_action_path: false,
    limit: 8,
  };
  dispatch(
    getForYouData({
      module: "getProductCategoriesDataRecommend",
      postData: reqObj,
    }),
  );
};

export const continueYouJourneyApi = (dispatch, authBroker) => {
  let req = {
    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    category_id: [],
    provider_id: "",
    search: "",
    sort: 1,
    page_size: 100,
    page: 1,
    type: "continue",
  };
  clickStreamUser("ContinueYourJourneyAsset", req, authBroker);
  dispatch(
    getProductCategoriesData({
      module: "getProductCategoriesDataMyCourse",
      postData: req,
    }),
  );
};

export const fetchNonMyOBLPList = (dispatch, authBroker) => {
  console.log("FETCH NON MY OBLP LIST");

  let req = {
    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    sort: 1,
    page_size: 12,
    page: 0,
    search: "",
    is_onboarding: 0,
    provider_id: "",
    isAll: false,
    language: "",
    type: "continue",
  };
  clickStreamUser("ContinueYourJourneyActionPath", req, authBroker);
  dispatch(
    getNonMyOBLPListing({
      URL: `${CONFIG.API_URL_BROKER}${API_LIST.BROKER_API.GET_MY_LP_LISTING}`,
      payload: req,
      isJSON: true,
      method: "post",
    }),
  );
};

export const logoutClearSession = () => {
  localStorage.removeItem(SessionKeys.API_TOKEN_BROKER);
  localStorage.removeItem(SessionKeys.COMPANY_ID);

  localStorage.removeItem("persist:root");
};

export const SessionKeys = {
  EMAIL: "EMAIL",
  EMAIL_SESSION: "EMAIL_SESSION",
  PASS: "PASSWORD",
  API_TOKEN: "API_TOKEN",
  API_TOKEN_BROKER: "API_TOKEN_LOGIN",
  IS_REMEMBERED: "IS_REMEMBERED",
  IS_PREMIUM: "IS_PREMIUM",
  REMIND_ME_LATER: "REMIND_ME_LATER",
  USERNAME: "USERNAME",
  IFRAME_USERNAME: "IFRAME_USERNAME",
  BROKER_ID: "BROKER_ID",
  COMPANY_ID: "COMPANY_ID",
  BROKER_NAME: "BROKER_NAME",
  HOSTINST_ID: "HOSTINST_ID",
  IS_AGGREED: "IS_AGGREED",
  USER_ID: "USER_ID",
  NOTI_SHOW: "NOTI_SHOW",
  IS_TOUR: "IS_TOUR",
  COMPLETE_TOUR: "COMPLETE_TOUR",
  FIRST_NAME: "FIRST_NAME",
  LAST_NAME: "LAST_NAME",
  SSO_ENABLED: "SSO_ENABLED",
  LOCATION_PATH_REDIRECT: "LOCATION_PATH_REDIRECT",
  SESSION_ID: "cart_session_id",
  LOGIN_COMPANY: "login_company",
  DYNAMIC_CONTENT: "dynamic_content",
  COACH_LOGIN: "COACH_LOGIN",

  //menu show config
  SHOW_ROLEPLAY: "SHOW_ROLEPLAY",
  SHOW_POINTS: "SHOW_POINTS",
  SHOW_DISCUSS_TAB: "SHOW_DISCUSS_TAB",
  SHOW_MY_WALL: "SHOW_MY_WALL",
  SHOW_OFFICE_NAME: "SHOW_OFFICE_NAME",
  SHOW_LEADERBOARD: "SHOW_LEADERBOARD",
  SHOW_MENTER_COACH: "SHOW_MENTER_COACH",

  //Language
  SELECTED_LANGUAGE: "SELECTED_LANGUAGE",
  NEW_AI_ROLEPLAY_TOKEN: "NEW_AI_ROLEPLAY_TOKEN",
  URL_COPIED: "URL_COPIED",
};

export const clickStreamUser = (eventName, eventObj, authBroker = {}) => {
  let evtObj = {
    browser: getBrowserName(),
    os: detectOS(),
    timestamp: Date.now(),
    pageName: eventName,
    eventType: eventName, // Page View, API Call, API Call REsponse, Click
    name: "finwell_lms",
    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    eventObj,
  };

  if (authBroker) {
    evtObj.user_id = authBroker?.payload?.user?.user_id;
    evtObj.first_name = authBroker?.payload?.user?.firstname;
    evtObj.user_email = authBroker?.payload?.user?.email;
  }

  window.captureMyEvents(eventName, evtObj);
};

const detectOS = () => {
  let userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
    windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
    iosPlatforms = ["iPhone", "iPad", "iPod"],
    os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "Mac OS";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (!os && /Linux/.test(platform)) {
    os = "Linux";
  }

  return os;
};

const getBrowserName = () => {
  let browserInfo = navigator.userAgent;
  let browser;
  if (browserInfo.includes("Opera") || browserInfo.includes("Opr")) {
    browser = "Opera";
  } else if (browserInfo.includes("Edg")) {
    browser = "Edge";
  } else if (browserInfo.includes("Chrome")) {
    browser = "Chrome";
  } else if (browserInfo.includes("Safari")) {
    browser = "Safari";
  } else if (browserInfo.includes("Firefox")) {
    browser = "Firefox";
  } else {
    browser = "unknown";
  }
  return browser;
};

export const checkCall = () => {
  // console.log('checkCall')
};

export const setIconForReport = (status) => {
  switch (status) {
    case "in-progress":
      return "/images/inprogress.svg";
    case "not-started":
    case "over-due":
      return "/images/not-started.svg";
    default:
      return "/images/check-report.svg";
  }
};

export const convertTimeFormat = (duration, isSecond = false, t = null) => {
  // console.log(isSecond ? duration : "")
  if (isSecond) {
    if (duration >= 86400) {
      return convertTimeInDaysHoursAndMin(duration, t);
    } else {
      let secondHand = duration % 60;
      duration = parseInt(duration / 60);
      if (secondHand) {
        // return `${duration} ${duration > 1 ? 'Mins' : 'Min'} ${secondHand} ${secondHand > 1 ? 'Secs' : 'Sec'}`
        if (duration > 60) {
          let hours = Math.floor(duration / 60);
          let minutes = duration % 60;
          hours = hours >= 10 ? hours : `0${hours}`;
          minutes = minutes >= 10 ? minutes : `0${minutes}`;
          secondHand = secondHand >= 10 ? secondHand : `0${secondHand}`;
          if (_.toNumber(minutes) === 0) {
            const hourLabel =
              hours > 1 ? (t ? t("Hours") : "Hours") : t ? t("Hour") : "Hour";
            const secLabel =
              secondHand > 1 ? (t ? t("Secs") : "Secs") : t ? t("Sec") : "Sec";
            return `${hours} ${hourLabel} ${secondHand} ${secLabel}`;
          } else {
            const hourLabel =
              hours > 1 ? (t ? t("Hours") : "Hours") : t ? t("Hour") : "Hour";
            const minLabel =
              minutes > 1 ? (t ? t("Mins") : "Mins") : t ? t("Min") : "Min";
            const secLabel =
              secondHand > 1 ? (t ? t("Secs") : "Secs") : t ? t("Sec") : "Sec";
            return `${hours} ${hourLabel} ${minutes} ${minLabel} ${secondHand} ${secLabel}`;
          }
        } else if (duration < 60) {
          let minutes = duration >= 10 ? duration : `0${duration}`;
          secondHand = secondHand >= 10 ? secondHand : `0${secondHand}`;
          if (_.toNumber(minutes) === 0) {
            const secLabel =
              secondHand > 1 ? (t ? t("Secs") : "Secs") : t ? t("Sec") : "Sec";
            return `${secondHand} ${secLabel}`;
          } else {
            const minLabel =
              minutes > 1 ? (t ? t("Mins") : "Mins") : t ? t("Min") : "Min";
            const secLabel =
              secondHand > 1 ? (t ? t("Secs") : "Secs") : t ? t("Sec") : "Sec";
            return `${minutes} ${minLabel} ${secondHand} ${secLabel}`;
          }
        } else if (duration === 60) {
          const secLabel =
            secondHand > 1 ? (t ? t("Secs") : "Secs") : t ? t("Sec") : "Sec";
          return `01 ${t ? t("Hour") : "Hour"} ${secondHand} ${secLabel}`;
        }
      } else {
        return convertTimeInHourAndMin(duration, t);
      }
    }
  } else {
    return convertTimeInHourAndMin(duration, t);
  }
};

export const formatSecondsHand = (duration) => {
  const secondsHand = duration >= 10 ? duration : `0${duration}`;
  return `${secondsHand} Sec${duration > 1 ? "s" : ""}`;
};

export const convertTimeInHourAndMin = (duration, t = null) => {
  if (duration > 60) {
    let hours = Math.floor(duration / 60);
    let minutes = duration % 60;
    hours = hours >= 10 ? hours : `0${hours}`;
    minutes = minutes >= 10 ? minutes : `0${minutes}`;
    if (_.toNumber(minutes) === 0) {
      const hourLabel =
        hours > 1 ? (t ? t("Hours") : "Hours") : t ? t("Hour") : "Hour";
      return `${hours} ${hourLabel}`;
    } else {
      const hourLabel =
        hours > 1 ? (t ? t("Hours") : "Hours") : t ? t("Hour") : "Hour";
      const minLabel =
        minutes > 1 ? (t ? t("Mins") : "Mins") : t ? t("Min") : "Min";
      return `${hours} ${hourLabel} ${minutes} ${minLabel}`;
    }
  } else if (duration === 0) {
    return "";
  } else if (duration < 60) {
    let minutes = duration >= 10 ? duration : `0${duration}`;
    const minLabel =
      minutes > 1 ? (t ? t("Mins") : "Mins") : t ? t("Min") : "Min";
    return `${minutes} ${minLabel}`;
  } else if (duration == 60) {
    return `01 ${t ? t("Hour") : "Hour"}`;
  }
};

export const convertTimeInDaysHoursAndMin = (duration, t = null) => {
  if (duration > 86400) {
    let day = Math.floor(duration / 3600) / 24;
    day = _.round(day);
    let remainingDuration = duration % 24;
    let hoursMin = "";
    if (remainingDuration) {
      hoursMin = convertTimeFormat(remainingDuration, true, t);
    }
    const dayLabel = day > 1 ? (t ? t("Days") : "Days") : t ? t("Day") : "Day";
    return `${day} ${dayLabel} ${hoursMin}`;
  } else {
    return `1 ${t ? t("Day") : "Day"}`;
  }
};

const htmlParse = (description) => {
  const parser = new DOMParser();

  // Parse the HTML string
  const doc = parser.parseFromString(description, "text/html");

  // Extract text content
  const text = doc.body.textContent;
  return text;
};

export const truncatedDescription = (description, maxLength) => {
  description = htmlParse(description);
  const truncatedText =
    description.length > maxLength
      ? `${description.substring(0, maxLength).replace(/\s+\S*$/, "")} ...`
      : description;
  return truncatedText;
};

export const formatDateTime = (dateString) => {
  const date = momentTimezone.tz(dateString, "America/New_York");
  const formattedTime = date.format("h:mma");
  const formattedDate = date.format("ddd, Do MMM YYYY");
  const timezoneShort = date.format("z");
  return `Begins ${formattedTime} ${timezoneShort}, ${formattedDate}`;
};

export const formatStartDateTime = (dateString, timeString, timezoneAbbr) => {
  const combinedDateTime = `${dateString.replaceAll("-", "/")} ${timeString}`;
  const date = moment.utc(combinedDateTime).tz(timezoneAbbr);
  const formattedTime = date?.format("h:mma");
  const formattedDate = date?.format("ddd, Do MMM YYYY");
  const timezoneShort = date?.format("z");

  return `Begins ${formattedTime} ${timezoneShort}, ${formattedDate}`;
};

export const isSessionWithinOneHour = (
  startDateString,
  startTimeString,
  endDateString,
  endTimeString,
  timezoneAbbr,
) => {
  const startCombinedDateTime = `${startDateString.replaceAll("-", "/")} ${startTimeString}`;
  const endCombinedDateTime = `${endDateString.replaceAll("-", "/")} ${endTimeString}`;

  const startDateTime = moment.utc(startCombinedDateTime).tz(timezoneAbbr);
  const endDateTime = moment.utc(endCombinedDateTime).tz(timezoneAbbr);

  // Get the current datetime in the specified timezone
  const currentDateTime = moment.utc().tz(timezoneAbbr);
  // Check if the current datetime is within the session start and end times
  const isWithinSession = currentDateTime?.isBetween(
    startDateTime,
    endDateTime,
    null,
    "[]",
  );
  // Calculate the difference in minutes between the session start datetime and the current datetime
  const timeDifferenceInMinutes = startDateTime?.diff(
    currentDateTime,
    "minutes",
  );
  // Check if the session is commencing within 1 hour (60 minutes) from now and is currently active
  return (
    isWithinSession ||
    (timeDifferenceInMinutes <= 60 && timeDifferenceInMinutes >= 0)
  );
};

export const isSessionWithinOneHourForLive = (
  startDateString,
  startTimeString,
  endDateString,
  endTimeString,
  timezoneAbbr,
) => {
  const startCombinedDateTime = `${startDateString.replaceAll("-", "/")} ${startTimeString}`;
  const endCombinedDateTime = `${endDateString.replaceAll("-", "/")} ${endTimeString}`;

  const startDateTime = moment.utc(startCombinedDateTime).tz(timezoneAbbr);
  const endDateTime = moment.utc(endCombinedDateTime).tz(timezoneAbbr);

  // Get the current datetime in the specified timezone
  const currentDateTime = moment.utc().tz(timezoneAbbr);
  // Check if the current datetime is within the session start and end times
  const isWithinSession = currentDateTime?.isBetween(
    startDateTime,
    endDateTime,
    null,
    "[]",
  );
  // Calculate the difference in minutes between the session start datetime and the current datetime
  const timeDifferenceInMinutes = startDateTime?.diff(
    currentDateTime,
    "minutes",
  );
  // Check if the session is commencing within 1 hour (60 minutes) from now and is currently active
  return isWithinSession
    ? 1
    : timeDifferenceInMinutes <= 60 && timeDifferenceInMinutes >= 0
      ? 2
      : 3;
};

export const findUpcomingSession = (sessions) => {
  const currentDate = new Date();

  const upcomingSessions = sessions.filter((session) => {
    const startDate = new Date(
      `${session.date_time[0].start_date} ${session.date_time[0].start_time}`,
    );

    // Compare with the current date and time
    return startDate > currentDate;
  });

  // Sort upcoming sessions by start date and time
  upcomingSessions.sort((a, b) => {
    const startDateA = new Date(
      `${a.date_time[0].start_date} ${a.date_time[0].start_time}`,
    );
    const startDateB = new Date(
      `${b.date_time[0].start_date} ${b.date_time[0].start_time}`,
    );
    return startDateA - startDateB;
  });

  // Return the first upcoming session
  return upcomingSessions.length > 0 ? upcomingSessions : null;
};

export const formatEndDateTime = (dateString, timeString, timezoneAbbr) => {
  const combinedDateTime = `${dateString.replaceAll("-", "/")} ${timeString}`;
  // const dateCombinedString = new Date(combinedDateTime);
  // const date = momentTimezone.tz(dateCombinedString, timezoneAbbr);
  const date = moment.utc(combinedDateTime).tz(timezoneAbbr);
  const formattedTime = date?.format("h:mma");
  const formattedDate = date?.format("ddd, Do MMM YYYY");
  const timezoneShort = date?.format("z");
  // Return the formatted string
  return `Ends ${formattedTime} ${timezoneShort}, ${formattedDate}`;
};

export const convertHoursToMins = (duration, t) => {
  if (!duration) return "";

  const convertArray = _.toString(duration).includes(":")
    ? duration.split(":")
    : [duration, 0];
  const hours = _.toNumber(convertArray[0]);
  const minutes = _.toNumber(convertArray[1]);

  // If t (translation function) is not provided, return total minutes (for backward compatibility)
  if (!t) {
    const hoursMinutes = hours * 60;
    const totalMinutes = hoursMinutes + minutes;
    return totalMinutes;
  }

  // Return formatted translated string
  let formattedString = "";

  if (hours > 0) {
    const hourLabel = hours === 1 ? t("hour") : t("hours");
    formattedString += `${hours} ${hourLabel}`;
  }

  if (minutes > 0) {
    if (formattedString) formattedString += " ";
    const minuteLabel = minutes === 1 ? t("minute") : t("minutes");
    formattedString += `${minutes} ${minuteLabel}`;
  }

  return formattedString || "0 " + t("minutes");
};

export const convertSecondsToMins = (duration) => {
  // console.log('SECONDS', duration)
  const totalMinutes = Math.floor(_.toNumber(duration) / 60);
  // console.log('SECONDS', totalMinutes)
  return totalMinutes;
};

export const convertMinutesToHoursAndMinutes = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours.toString().padStart(2, "0")} Hr ${mins.toString().padStart(2, "0")} Mins`;
};

export const getWordSpeedType = (wpm) => {
  if (wpm >= 1 && wpm <= 120) {
    return "Slow";
  } else if (wpm > 120 && wpm <= 160) {
    return "Appropriate";
  } else if (wpm > 160) {
    return "Faster";
  } else {
    return "";
  }
};

export const timezoneTagName = (abbr) => {
  switch (abbr) {
    case "PDT":
      return "PT";
    case "EDT":
      return "ET";
    case "ADT":
      return "AT";
    case "MDT":
      return "MT";
    case "NDT":
      return "NT";
    case "CDT":
      return "CT";
    default:
      return abbr;
  }
};

export const timezoneArea = (offset) => {
  switch (offset) {
    case "-0500":
      return "America/Chicago"; // CST
    case "-0600":
      return "America/Denver"; // MST
    case "-0400":
      return "America/New_York"; // EST
    case "-0700":
      return "America/Los_Angeles"; // PT (480)
    case "-0230":
      return "America/St_Johns"; // NT
    case "-0300":
      return "America/Blanc-Sablon"; // AT
    default:
      return "America/New_York";
  }
};

export const videoExtensionType = (extension) => {
  switch (extension) {
    case "m3u8":
      return "application/x-mpegURL";
    default:
      return "video/mp4";
  }
};

export const applyTheme = (branding) => {
  $("body").addClass("cus-bro-theme");
  $("html").css("--color-element-1", branding.primary_color);
  $("html").css("--primary_color", branding.primary_color);

  $("html").css("--primary_light_color", branding.primary_light_color);

  $("html").css("--secondary_color", branding.secondary_color);

  $("html").css("--secondary_light_color", branding.secondary_light_color);

  $("html").css("--primary_btn_color", branding.primary_btn_color);

  $("html").css("--primary_btn_light_color", branding.primary_btn_light_color);

  $("html").css("--progress_color", branding.progress_color);

  $("html").css("--primary_btn_text_color", branding.primary_btn_text_color);

  // $("html").css(
  //     "--icon-color",
  //     branding.icon_color
  // );
  // $("html").css(
  //     "--currntweek",
  //     branding.currwk_header_color
  // );
  // $("html").css(
  //     "--past-week",
  //     branding.ptwk_header_color
  // );
  // $("html").css(
  //     "--future-week",
  //     branding.ftwk_header_color
  // );
  // $("html").css(
  //     "--footer-bg-color",
  //     branding.footer_bg_color
  // );
  // $("html").css(
  //     "--footer-text-color",
  //     branding.footer_text_color
  // );

  // if (branding.course_launch_url) {
  //     console.log('COURSE LAUNCH URL', branding.course_launch_url)
  //     $(".cus-bro-theme .video_img").css('background', 'url(' + branding.course_launch_url + ')')
  // }
  return true;
};

export const UserIsLoggedIn = () => {
  LOGIN_CHANNEL.postMessage({ login: true });
};

export const IsLogin = () => {
  LOGIN_CHANNEL.onmessage = (event) => {
    if (event.data && event.data?.login) {
      window.location.reload();
    }
  };
};

export const calculateRolePlayScore = (data) => {
  let point = 0;
  Object.keys(data).forEach((d) => {
    point = point + _.toNumber(data[d]);
  });
  return point;
};

export const fixedToDecimal = (value, decimalValue) => {
  return _.toNumber(value).toFixed(decimalValue);
};

export const rolePlayStatus = (type, role = "participant") => {
  switch (type) {
    case "draft":
    default:
      return <span className="pfrpending draftrev">Draft</span>;
    case "pending_review":
      return <span className="pfrpending">Pending Review</span>;
    case "feedback_received":
      return (
        <span className="frdone">
          Feedback {role === "participant" ? "Received" : "Provided"}
        </span>
      );
  }
};

export const starRatingCaptions = (rating) => {
  if (rating >= 1 && rating < 2) {
    return "Give it another go!";
  } else if (rating >= 2 && rating < 3) {
    return "You're almost there!";
  } else if (rating >= 3) {
    return "You nailed it!";
  }
};

export const getDateTime = (time, userDetails) => {
  if (time === undefined) {
    return "- -";
  }

  const timezoneOffset = !_.isEmpty(userDetails.timezone)
    ? userDetails.timezone.replace(":", "")
    : "-0500";
  const area = timezoneArea(timezoneOffset);
  var today = moment.unix(time).tz(area)?.format("MMM DD YYYY h:mm A");
  return today;
};

export const getFormatCourseListFromWoo = (course, isPremiumUser) => {
  // for (let course of courseList) {
  course.is_purchased = course.is_paid;
  course.showBuy = course.is_purchased ? false : true;
  course.is_bundle = false;
  course.is_free = false;
  if (course?.sfdc_product_type?.toLowerCase() === "basic") {
    course.showBuy = false;
    course.is_paid = true;
    course.is_free = true;
  } else if (course?.sfdc_product_type?.toLowerCase() === "premium") {
    if (isPremiumUser) {
      course.showBuy = false;
      course.is_paid = true;
      course.is_free = true;
    } else {
      if (course.product_offer_for_basic) {
        course.sale_price = 0.0;
        course.regular_price = 0.0;
      } else {
        course.sale_price = course.product_basic_price;
        course.regular_price = course.product_market_price;
      }
    }
  } else if (course?.sfdc_product_type?.toLowerCase() === "alacarte") {
    if (isPremiumUser) {
      if (course.product_offer_for_premium) {
        course.sale_price = 0.0;
        course.regular_price = 0.0;
      } else {
        course.sale_price = course.product_premium_price;
      }
    } else {
      if (course.product_offer_for_basic) {
        course.sale_price = 0.0;
        course.regular_price = 0.0;
      } else {
        course.sale_price = course.product_basic_price;
      }
    }
    course.regular_price = course.product_market_price;
  } else if (course?.sfdc_product_type?.toLowerCase() === "bundle") {
    course.is_bundle = true;
    for (let cl of course.course_list) {
      cl.source = course.source;
      cl.is_free = course.is_free;
    }
  }
  if (course?.sfdc_product_type?.toLowerCase() !== "bundle") {
    if (course.durationUnit === "Hours") {
      course.duration = convertHoursToMins(course.duration);
    } else if (course.durationUnit === "Seconds") {
      course.duration = convertTimeFormat(course.duration, true);
    }
    // course.duration = convertTimeFormat(
    //     _.toNumber(course.duration)
    // );
    course.durationUnit = "";
  } else {
    // console.log('Duration', course)
    for (let cl of course.course_list) {
      if (cl.durationUnit === "Hours") {
        cl.duration = convertHoursToMins(cl.duration);
      }
      cl.duration = convertTimeFormat(_.toNumber(cl.duration));
      cl.durationUnit = "";
    }
  }
  // }
  return course;
};

export const formatLPCoursesList = (learning) => {
  if (learning.coursesList) {
    learning.is_manager_checklist = false;
    learning.newCourseList = [];
    for (let [index, course] of learning.coursesList.entries()) {
      let currentCourse = course;
      let nextCourse = learning.coursesList[index + 1];
      if (learning.sequence === 1) {
        console.log("is sequence");
        if (index === 0) {
          currentCourse.isLock = false;
        }
        currentCourse.isLock =
          currentCourse.isLock === false ? currentCourse.isLock : true;
        if (currentCourse.crs_progress > 0) {
          console.log("CURRENT PROGRESS IS MORE THAN ZERO");
          // currentCourse.isLock = currentCourse.crs_progress >= 100 ? false;
          if (index !== learning.coursesList.length - 1) {
            console.log("INDEX IS NOT LAST");
            nextCourse.isLock =
              _.toNumber(currentCourse.crs_progress) >= 100 &&
              !currentCourse.isLock
                ? false
                : true;
            console.log("NEXT COURSE ISLOCK", nextCourse.isLock);
          }
        }
      } else {
        currentCourse.isLock = currentCourse.isLock
          ? currentCourse.isLock
          : false;
      }
      currentCourse.duration = convertTimeFormat(
        _.toNumber(currentCourse.duration),
      );
      currentCourse.durationUnit = "";
      // console.log("detaiiii", course)
      if (index < learning.coursesList.length - 1) {
        if (
          !currentCourse?.is_checklist_approved &&
          currentCourse?.is_checklist_present
        ) {
          nextCourse.isLock = nextCourse.crs_progress <= 100 ? true : false;
        } else if (
          currentCourse?.is_checklist_approved &&
          currentCourse?.is_checklist_present
        ) {
          nextCourse.isLock = false;
        }

        if (currentCourse.is_checklist_present) {
          learning.is_manager_checklist = true;
        }
      }
    }
    for (let course of learning.coursesList) {
      course.is_manager_checklist = learning.is_manager_checklist;
    }
    // learning.courseList[0].isLock = false;

    for (let course of learning.coursesList) {
      course.is_manager_checklist = learning.is_manager_checklist;
      if (course.durationUnit === "Hours") {
        const convertArray = _.toString(course.duration).includes(":")
          ? course.duration.split(":")
          : [course.duration, 0];
        const hoursMinutes = _.toNumber(convertArray[0]) * 60;
        const minutes = _.toNumber(convertArray[1]);
        const totalMinutes = hoursMinutes + minutes;
        course.duration = totalMinutes;
      }
      if (_.toNumber(course.duration) > 60) {
        let hours = Math.floor(course.duration / 60);
        let minutes = course.duration % 60;
        hours = hours >= 10 ? hours : `0${hours}`;
        minutes = minutes >= 10 ? minutes : `0${minutes}`;
        // console.log(course.duration, hours, minutes)
        // course.duration = `${hours}:${minutes}`
        course.duration = `${hours} ${
          hours > 1 ? "Hours" : "Hour"
        } ${minutes} ${minutes > 1 ? "Mins" : "Min"}`;
        course.durationUnit = "";
      } else if (_.toNumber(course.duration) < 60) {
        // console.log('Minutes')
        course.duration = `${course.duration} ${
          course.duration > 1 ? "Mins" : "Min"
        }`;
        course.durationUnit = "";
      } else {
        // console.log('hour')
        course.duration = "1 Hour";
        course.durationUnit = "";
      }
    }
  }
  return learning;
};

export const getStepIndex = (
  targetIndex,
  userRole,
  isPremium,
  isGuest = false,
) => {
  console.log("rolesData: ", userRole, isPremium, isGuest);
  let arrName = getJoyRideScript(userRole, isPremium, isGuest);
  for (let [i, record] of arrName.entries()) {
    if (record.target === targetIndex) {
      return i;
    }
  }
};

export const getJoyRideScript = (
  userRole,
  isPremium,
  isGuest = false,
  t = null,
  hasRecommendations = true,
) => {
  let arrName = isGuest
    ? joyRideGuestSteps
    : t
      ? getFinwellSteps(t, hasRecommendations)
      : finwellSteps;
  if (userRole === "manager") {
    if (isPremium) {
      arrName = joyRideStepsManagerPremium;
    } else {
      arrName = joyRideStepsManager;
    }
  } else if (isPremium) {
    arrName = isGuest ? joyRideGuestStepsPremium : joyRideStepsPremium;
  }
  return arrName;
};

export const showOBLPProgessNaming = (progress) => {
  if (_.toNumber(progress) === 0) {
    return "Not Started";
  } else if (_.toNumber(progress) === 100) {
    return "Completed";
  } else {
    return "In Progress";
  }
};

export const getFrequency = (frequency) => {
  switch (frequency) {
    case "Monthly":
      return "month";
    case "One time":
      return "";
    default:
      return "";
  }
};

export const webViewCallbackHandler = (data) => {
  if (window.callbackHandler !== undefined) {
    window.callbackHandler.postMessage(data);
  }
  if (window.webkit !== undefined) {
    if (window.webkit.messageHandlers.callbackHandler !== undefined) {
      window.webkit.messageHandlers.callbackHandler.postMessage(data);
    }
  }
};

export const getPriceInfoForEntity = (info) => {
  const {
    isUserPremium,
    productType,
    premiumPrice,
    basicPrice,
    offerPremiumPrice,
    offerBasicPrice,
    offerEndDate,
    offerStartDate,
    source,
    productIsPaid,
    inAddToCart,
  } = info;

  let isFree = false;
  let isPaid = false;
  let isAddToCart = false;
  let price = 0;

  if (source === "xsel" || source === "ecom") {
    if (productType === "alacarte") {
      isFree = false;
      isPaid = productIsPaid;
      isAddToCart = inAddToCart;
      price = isUserPremium ? premiumPrice : basicPrice;
      if (
        moment(offerStartDate).isSameOrAfter(moment()) &&
        moment(offerEndDate).isSameOrBefore(moment())
      ) {
        price = isUserPremium ? offerPremiumPrice : offerBasicPrice;
      }
    } else {
      if (!isUserPremium) {
        if (productType === "basic") {
          isFree = true;
        } else {
          isFree = false;
          isPaid = productIsPaid;
          isAddToCart = inAddToCart;
        }
      } else {
        isFree = true;
      }
      price = isUserPremium ? premiumPrice : basicPrice;
      if (
        moment(offerStartDate).isSameOrAfter(moment()) &&
        moment(offerEndDate).isSameOrBefore(moment())
      ) {
        price = isUserPremium ? offerPremiumPrice : offerBasicPrice;
      }
    }
  } else {
    isFree = true;
    isPaid = false;
    isAddToCart = false;
  }

  return {
    isFree,
    isPaid,
    isAddToCart,
    price,
  };
};

export const getProcureInfo = (info) => {
  if (!_.isEmpty(info)) {
    return {
      isFree: info.selling_price === 0 || info.is_purchased,
      isPurchased: info.is_purchased,
      isAddToCart: false,
      isOffer: info.is_offer,
      price: info.selling_price,
      offerPrice: info.offer_price,
      showText: info.enrolled_text,
      textColor: info.enrolled_text_color_code,
      teaserViewed: info.teaser_view,
      teaserAccessed: info.teaser_view_completed,
    };
  }
  return {
    isFree: true,
    isPurchased: false,
    isAddToCart: false,
    isOffer: false,
    showText: "",
    textColor: "#DC3872",
    teaserViewed: false,
    teaserAccessed: false,
  };
};

export const FreePaidSubscription = () => {
  return <span className="signup-btn">Free with paid subscriptions</span>;
};

export const emptyComp = () => {
  return <></>;
};

export const ProductCardPriceInfo = (stmt, colorCode) => {
  return (
    <span
      className="signup-btn offer-price-com"
      style={{ color: colorCode }}
      dangerouslySetInnerHTML={{ __html: stmt }}
    ></span>
  );
};

export const ProductCardPriceInfoWithoutPriceText = (stmt, colorCode) => {
  console.log("stmt", stmt);
  stmt = stmt?.replace("Price:", "");
  return (
    <span
      className="signup-btn offer-price-com"
      style={{ color: colorCode }}
      dangerouslySetInnerHTML={{ __html: stmt }}
    ></span>
  );
};

export const FreeForYou = () => {
  return <span className="signup-btn">Free for you</span>;
};

export const PurchasedOn = (date) => {
  return <span className="price-band">Purchased on {date}</span>;
};

export const PriceAt = (price, inCart = false) => {
  return (
    <>
      <span className="signup-btn">Price: ${price}</span>
      {inCart && <span class="pc-datebar">In your cart</span>}
    </>
  );
};

// Function to format the hour and minute
const formatTime = (dateString, timezone) => {
  const date = new Date(dateString * 1000);
  // Use Intl.DateTimeFormat to format the date in EST
  const options = {
    hour: "numeric",
    minute: "numeric",
    timeZone: timezone, // EST is represented by the America/New_York time zone
    hour12: true, // Use 12-hour clock
  };
  const formatter = new Intl.DateTimeFormat("en-US", options);
  const estDate = formatter.format(date);
  const dateInNewYork = moment.tz(timezone ? timezone : "America/New_York");
  const timezoneShort = dateInNewYork.format("z");
  return `${estDate} ${timezoneShort}`;

  // return `${formattedHours}:${formattedMinutes} ${ampm}`;
};

export const PriceForSession = (enrolledText, endTime, userDetails) => {
  return (
    <>
      {enrolledText ? <span className="signup-btn">{enrolledText}</span> : ""}
      <span class="pc-datebar signup-btn">
        Live now, ends at {formatTime(endTime, userDetails?.timezoneAbbr)}
      </span>
    </>
  );
};

export const PriceInfo = (price, time) => {
  return (
    <>
      {price ? (
        <span class="signup-btn">Price: ${price}</span>
      ) : (
        <span className="signup-btn">Free for you</span>
      )}
      {/* <span class="signup-btn">Price: ${price}</span> */}
      <span class="pc-datebar">{formatDateTime(time)}</span>
    </>
  );
};
export const SessionPrice = (price) => {
  return (
    <>
      <div class="price-bar">
        Price: <span> ${price}</span>
      </div>
    </>
  );
};

export const getNumberOfWeeksInMonth = (year, month) => {
  console.log("year, month ", year + ", " + month);
  let startDate = moment([year, month]);
  let firstDay = moment(startDate).startOf("month");
  let endDay = moment(startDate).endOf("month");
  let monthRange = moment.range(firstDay, endDay);

  let weeks = [];
  for (let mday of monthRange.by("days")) {
    // console.log("mday", mday.week());
    if (weeks.indexOf(mday.week()) === -1) {
      weeks.push(mday.week());
    }
  }

  let calendar = [];
  for (let index = 0; index < weeks.length; index++) {
    var weeknumber = weeks[index];

    let firstWeekDay = moment(firstDay).week(weeknumber).day(0);
    if (firstWeekDay.isBefore(firstDay)) {
      firstWeekDay = firstDay;
    }

    let lastWeekDay = moment(endDay).week(weeknumber).day(6);
    if (lastWeekDay.isAfter(endDay)) {
      lastWeekDay = endDay;
    }

    //console.log("\n week number: " + index, firstWeekDay.format("DD-MM-YYYY"), lastWeekDay.format("DD-MM-YYYY"));
    // document.write("<br>week number: " + index + " day: " + firstWeekDay.format("DD-MM-YYYY") + " to " + lastWeekDay.format("DD-MM-YYYY"))
    let weekRange = moment.range(firstWeekDay, lastWeekDay);
    calendar.push(weekRange);
  }

  console.log("weeklength: ", calendar.length);

  return calendar.length;
};

export const isInCurrentMonth = (currentMonth, startMonth, endMonth, date) => {
  // let startMonth = moment().startOf("month").clone().add(currentMonth, "M").startOf("M");
  // let endMonth = startMonth.clone().endOf("M");
  console.log("rangeDates: ", startMonth, endMonth, date);
  let range = moment.range(startMonth, endMonth);
  let date1 = new Date(date);
  console.log("rangeDatesCompare: ", range.contains(date1));
  return range.contains(date);
};

export const isConatainsSymbol = (str) => {
  const regex = /[!@#$%^&*()\-+={}[\]:;"'<>,.?\/|\\]/;
  if (regex.test(str)) {
    return true;
  } else {
    return false;
  }
};

export const randomGenerator = (length = 8) => {
  let chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var result = "";
  for (var i = length; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)];
  return result;
};

export const subscriptionTrailType = (days) => {
  switch (days) {
    case 7:
      return "week";
    case 30:
      return "month";
    case 90:
      return "quater";
    case 180:
      return "half year";
    case 360:
      return "year";
    default:
      return "month";
  }
};

export const encyptData = (obj) => {
  var key = CryptoJS.enc.Utf8.parse("bbf0c21d0674978d115dfffe91a734a5"); // Use Utf8-Encoder.
  var iv = CryptoJS.enc.Utf8.parse("15db1af7ed6d53f5"); // Use Utf8-Encode

  let obj1 = { name: "suresh", email: "sureshwa@gmail.com" };

  let json = JSON.stringify(obj);
  var encryptedCP = CryptoJS.AES.encrypt(json, key, { iv: iv });
  var decryptedWA = CryptoJS.AES.decrypt(encryptedCP, key, { iv: iv });

  var encryptedBase64 = encryptedCP.toString(); // Short for: encryptedCP.ciphertext.toString(CryptoJS.enc.Base64);
  // var decryptedUtf8 = decryptedWA.toString(CryptoJS.enc.Utf8);               // Avoid the Base64 detour.
  // Alternatively: CryptoJS.enc.Utf8.stringify(decryptedWA);
  // console.log("Ciphertext (Base64)  : " + encryptedBase64)
  // console.log("Ciphertext Decrypted data (Utf8): " + decryptedUtf8);
  return encryptedBase64;
};

export const redirectToPageUtil = (
  course,
  navigate,
  authBroker,
  setCourseData,
  dispatch,
  shareClick,
  from = "course",
  lpId = "",
  lpSource = "",
  is_level = "false",
  level_id = "",
  isMobile = false,
) => {
  if (shareClick === "share") {
    localStorage.setItem(SessionKeys.URL_COPIED, "c");
  }
  if (isMobile) {
    let obj = {
      type: course.product_type,
      obj: course,
      method: "navigate-to-detail-page",
    };
    if (window.callbackHandler != undefined) {
      window.callbackHandler.postMessage(JSON.stringify(obj));
    } else if (window.webkit != undefined) {
      if (window.webkit.messageHandlers.callbackHandler != undefined) {
        window.webkit.messageHandlers.callbackHandler.postMessage(
          JSON.stringify(obj),
        );
      }
    }
    return;
  }
  // console.log("course 2");
  if (course?.product_type === "bundle") {
    let paramsReq = {
      lp_id: course.id,
      source: course?.origin,
      via: from,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    navigate(`/bundleDetail?c=${encodedUrl}`);
  } else if (course.product_type === "service") {
    let paramsReq = {
      service_code: course?.crscd,
      service_id: course?.id,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    let url = `/coaching-detail?c=${encodedUrl}`;
    navigate(url);
  } else if (
    course?.product_type === "learningpath" ||
    course?.entity_type === "learningpath"
  ) {
    goToLPDetailUtil(course, navigate, 0);
  } else if (course?.product_type === "video") {
    let paramsReq = {
      code: course.crscd,
      source: course.source,
      is_paid: "false",
      lp_id: lpId,
      via_lp: "false",
      from: from,
      lp_source: lpSource,
    };
    if (level_id) {
      paramsReq.level_id = level_id;
      paramsReq.is_level = "true";
    }
    if (course?.is_home) {
      paramsReq.is_home = course.is_home;
    }

    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);

    let url = `/video-view-page/${course.id}/?c=${encodedUrl}`;
    navigate(url);
  } else if (course?.product_type === "roleplay") {
    navigate(`/learn/roleplay/detail/${course?.id}`);
  } else if (
    (course?.source === "ecom" || course?.source === "xsel") &&
    !course?.is_paid
  ) {
    let paramsReq = {
      source: course?.source,
      cid: course.id ? course.id : course?.wc_post_id,
      price: course.priceInfo.price,
      is_paid: "false",
      from: from,
      lp_id: lpId,
      lp_source: lpSource,
      is_level: is_level,
      level_id: level_id,
    };
    if (course.provider_id) {
      paramsReq.provider_id = course.provider_id;
      paramsReq.provider_name = course.provider_name
        ? course.provider_name
        : "";
    }
    if (course?.is_home) {
      paramsReq.is_home = course.is_home;
    }
    if (course?.from_sub) {
      paramsReq.from_sub = course.from_sub;
    }

    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    // setCourseDetailData(course);
    // let url = `/moduleDetail/${course?.crscd}/?source=${course?.source}&cid=${course.id ? course.id : course?.wc_post_id}&price=${course.priceInfo.price}&is_paid=false`
    // url = url + `&from=${from}&lp_id=${lpId}&lp_source=${lpSource}&is_level=${is_level}&level_id=${level_id}`
    // if (level_id) {
    //     url = url + `&is_level=${is_level}&level_id=${level_id}`
    // }
    let url = `/moduleDetail/${course?.crscd}/?c=${encodedUrl}`;

    navigate(url);
    // navigate(`/shopping/${course.id}/?addToCart=${course?.is_addtocart}`);
  } else if (
    course?.is_paid === "" ||
    course?.is_paid === undefined ||
    course?.is_paid
  ) {
    if (course?.source === "broker") {
      setCourseData(course);
      // console.log("course redirect to module");
      // dispatch(
      //     getAssignBrokerCourse({
      //         module: "assignedCourseBroker",
      //         postData: {
      //             token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      //             entity_type: "courses",
      //             entity_id: course?.wc_post_id ? _.toNumber(course?.wc_post_id) : course?.id,
      //             origin: "broker",
      //             $number_of_days: "",
      //             is_type: "free",
      //         },
      //     })
      // );

      goToModuleDetail(course, navigate, from, lpId, lpSource, dispatch);
    } else {
      // console.log("course redirect to assign", course);

      setCourseData(course);
      if (!course?.priceInfo?.isFree || !course.isLoggedIn) {
        goToModuleDetail(course, navigate, from, lpId, lpSource, dispatch);
      } else {
        dispatch(
          getAssignCourse({
            module: "assign-course",
            postData: {
              user_id: authBroker?.payload?.user.user_id,
              course_id: course?.crscd,
            },
          }),
        );
        // dispatch(
        //     getAssignBrokerCourse({
        //         module: "assignedCourseBroker",
        //         postData: {
        //             token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        //             entity_type: "courses",
        //             entity_id: course?.crscd,
        //             origin: "xsel",
        //             number_of_days: course?.course_days,
        //             is_type: course?.is_free ? "free" : "paid",
        //             comment: course?.name,
        //         },
        //     })
        // );
      }
    }
  }
};

export const goToModuleDetail = (
  courseData,
  navigate,
  from = "course",
  lpId = "",
  lpSource = "",
  dispatch,
  is_level = "false",
  level_id = "",
) => {
  console.log("lpId111 ", courseData.journey, courseData?.is_onboarding);
  if (
    (courseData.journey !== undefined && !courseData.journey) ||
    courseData?.is_onboarding === "0" ||
    true
  ) {
    navigateToCourseLaunch(
      courseData,
      navigate,
      from,
      lpId,
      lpSource,
      is_level,
      level_id,
      dispatch,
    );
  } else {
    let paramsReq = {
      source: courseData?.source,
      cid: courseData.id ? courseData.id : courseData?.wc_post_id,
      is_paid: "true",
      from: from,
      lp_id: lpId,
      lp_source: lpSource,
      is_level: is_level,
      level_id: level_id,
    };

    if (courseData.course_categoryId) {
      paramsReq.catId = courseData.course_categoryId;
      paramsReq.via_cat = "true";
    } else if (courseData.isLevel) {
      paramsReq.lp_id = courseData.lp_id;
      paramsReq.via_lp = "true";
      paramsReq.is_level = "true";
      paramsReq.level_id = courseData.level_id;
    } else if (courseData.lp_id) {
      paramsReq.lp_id = courseData.lp_id;
      paramsReq.via_lp = "true";
    }
    if (courseData.provider_id) {
      paramsReq.provider_id = courseData.provider_id;
      paramsReq.provider_name = courseData.provider_name
        ? courseData.provider_name
        : "";
    }
    if (courseData?.is_home) {
      paramsReq.is_home = courseData.is_home;
    }
    if (courseData?.from_sub) {
      paramsReq.from_sub = courseData.from_sub;
    }
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);

    let url = `/moduleDetail/${courseData?.crscd}/?c=${encodedUrl}`;

    // sessionStorage.setItem('moduleForTour', url);
    navigate(url);
  }
};

export const navigateToCourseLaunch = (
  courseData,
  navigate,
  from = "course",
  lpId = "",
  lpSource = "",
  is_level = "false",
  level_id = "",
  dispatch,
) => {
  console.log("lpId111122 ", lpId);
  if (localStorage.getItem(SessionKeys.URL_COPIED) !== "c") {
    dispatch(setIsLoadingGlobal(true));
  }
  axios
    .get(
      CONFIG.API_URL_REAL_BROKER +
        "wp-admin/admin-ajax.php?action=get_all_course_modules&course_code=" +
        courseData.crscd +
        "&token=" +
        localStorage.getItem(SessionKeys.API_TOKEN_BROKER) +
        "&language=1",
    )
    .then((response) => {
      console.log("responseDirect", response.data);

      dispatch(setIsLoadingGlobal(false));
      if (response.data.status) {
        let m = response.data?.data?.modules[0];
        let courseID =
          courseData?.source === "broker" ? courseData.id : courseData.crscd;
        let paramsReq = {
          source: courseData?.source,
          cid: courseData.id ? courseData.id : courseData?.wc_post_id,
          from: from,
          courseId: courseID,
          // courseTitle: courseData.name,
          mId: m?.module_id,
        };
        if (courseData.provider_id) {
          paramsReq.provider_id = courseData.provider_id;
          paramsReq.provider_name = courseData.provider_name
            ? courseData.provider_name
            : "";
        }

        if (courseData.course_categoryId) {
          paramsReq.cat_id = courseData.course_categoryId;
          paramsReq.via_cat = "true";
        } else if (is_level === "true") {
          paramsReq.lp_id = lpId;
          paramsReq.via_lp = "true";
          paramsReq.lp_source = "broker";
          paramsReq.is_level = "true";
          paramsReq.level_id = level_id;
        } else if (lpId) {
          paramsReq.lp_id = lpId;
          paramsReq.via_lp = "true";
          paramsReq.lp_source = "broker";
        }

        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        let pathname = `/courseDetail/${courseData.crscd}?c=${encodedUrl}`;
        const fullUrl = window.location.origin + pathname;

        if (localStorage.getItem(SessionKeys.URL_COPIED) === "c") {
          localStorage.removeItem(SessionKeys.URL_COPIED);
          navigator.clipboard
            .writeText(fullUrl)
            .then(() => {
              console.log("URL copied to clipboard:", fullUrl);
              const componentKey = sessionStorage.getItem("shareComponentKey");
              console.log("Dispatching urlCopied event with componentKey:", componentKey);
              // dispatch(setIsLoadingGlobal(false));
              const event = new CustomEvent("urlCopied", {
                detail: { componentKey },
              });
              window.dispatchEvent(event);
              sessionStorage.removeItem("shareComponentKey");
            })
            .catch((err) => {
              console.error("Failed to copy URL:", err);
              // dispatch(setIsLoadingGlobal(false));
            });
        } else {
          // window.open(fullUrl,"_blank");
          clickStreamUser(
            "asset-detail-navigation",
            {
              url: pathname,
              fromPage: window.location.pathname + "" + window.location.search,
            },
            {},
          );
          navigate(pathname, {
            state: {
              from: window.location.pathname + "" + window.location.search,
            },
          });
        }
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

export const navigateToView = (item) => {
  console.log("item------", item);
  let url = "";
  if (_.toLower(item?.sfdc_product_type) === "bundle") {
    let paramsReq = {
      lp_id: item?.product_id,
      source:
        _.lowerCase(item?.source) === "ecom" ||
        _.lowerCase(item?.source) === "xsel"
          ? "xsel"
          : _.lowerCase(item?.source),
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    url = `/bundleDetail?c=${encodedUrl}`;
  } else if (item?.product_type === "videos") {
    let paramsReq = {
      code: item?.course_code,
      source:
        _.lowerCase(item?.source) === "ecom" ||
        _.lowerCase(item?.source) === "xsel"
          ? "xsel"
          : _.lowerCase(item?.source),
      is_paid: item?.priceInfo.isFree,
    };
    if (!_.isEmpty(item.categoryId)) {
      paramsReq.catId = item?.categoryId[0];
    }
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    url = `/video-view-page/${item?.product_id}/?c=${encodedUrl}`;
  } else if (item?.product_type === "service") {
    let paramsReq = {
      service_code: item?.service_code,
      service_id: item?.product_id,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    url = `/coaching-detail?c=${encodedUrl}`;
  } else if (item?.product_type === "learningpath") {
    let paramsReq = {
      lp_id: item?.is_cart ? item?.post_id : item?.product_id,
      is_level: "false",
      source:
        _.lowerCase(item?.source) === "ecom" ||
        _.lowerCase(item?.source) === "xsel"
          ? "xsel"
          : _.lowerCase(item?.source),
    };

    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    url = `/lpDetail?c=${encodedUrl}`;
  } else if (item?.product_type === "certificate") {
    let paramsReq = {
      event_id: item?.eventId,
      event_code: item?.event_code,
      fromCert: "true",
      source:
        _.lowerCase(item?.source) === "ecom" ||
        _.lowerCase(item?.source) === "xsel"
          ? "xsel"
          : _.lowerCase(item?.source),
    };

    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    url = `/event-detail?c=${encodedUrl}`;
  } else if (item?.product_type === "course") {
    let paramsReq = {
      source:
        _.lowerCase(item?.source) === "ecom" ||
        _.lowerCase(item?.source) === "xsel"
          ? "xsel"
          : _.lowerCase(item?.source),
      cid: item.product_id,
      is_paid: "true",
    };
    if (item?.course_categoryId) {
      paramsReq.catId = item?.course_categoryId;
      paramsReq.via_cat = "true";
    } else if (item?.isLevel) {
      paramsReq.lp_id = item?.lp_id;
      paramsReq.via_lp = "true";
      paramsReq.is_level = "true";
      paramsReq.level_id = item?.level_id;
    } else if (item?.lp_id) {
      paramsReq.lp_id = item?.lp_id;
      paramsReq.via_lp = "true";
    }

    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);

    url = `/moduleDetail/${item?.course_code}/?c=${encodedUrl}`;
  } else if (item?.product_type === "session") {
    let paramsReq = {
      event_id: item.eventId,
      event_code: item.event_code,
      source: "ecom",
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    url = `/event-detail?c=${encodedUrl}`;
  } else if (item?.product_type === "roleplay") {
    url = `/learn/roleplay/detail/${item?.product_id}`;
  }
  return url;
};

export const formatCartProductData = (cartData) => {
  console.log("cart-data", cartData);
  let tags = [];
  let logoURL = "";
  let btnTitle = "";
  let logoAltText = "";
  if (!_.isEmpty(cartData.provider)) {
    tags.push(cartData.provider.provider_display_name);
    logoURL = cartData.provider.provider_img;
  }
  if (
    cartData.sfdc_product_type.toLowerCase() === "bundle" ||
    cartData.product_type.toLowerCase() === "learningpath"
  ) {
    if (cartData.product_type.toLowerCase() === "learningpath") {
      tags.push("Action Path");
      logoAltText = "LP";
    }
    // tags.push('combo')
    if (cartData.courses_count) {
      tags.push(
        `${cartData.courses_count} Course${cartData.courses_count > 1 ? "s" : ""}`,
      );
    }
    if (cartData.videos_count) {
      tags.push(
        `${cartData.videos_count} Video${cartData.videos_count > 1 ? "s" : ""}`,
      );
    }
    if (cartData.level_count) {
      tags.push(
        `${cartData.level_count} Level${cartData.level_count > 1 ? "s" : ""}`,
      );
    }
    if (cartData.lps_count) {
      tags.push(
        `${cartData.lps_count} Action Path${cartData.lps_count > 1 ? "s" : ""}`,
      );
    }
    if (cartData.event_count) {
      tags.push(
        `${cartData.event_count} Event${cartData.event_count > 1 ? "s" : ""}`,
      );
    }
  } else {
    if (
      cartData?.product_type != "coach" &&
      cartData?.product_type != "service"
    ) {
      tags.push(
        cartData?.product_type === "certificate"
          ? "Session"
          : cartData?.product_type === "videos"
            ? "Video"
            : getEntityType(cartData.product_type),
      );
    }
    if (cartData.product_type == "course") logoAltText = "CR";
    else if (cartData.product_type == "videos") logoAltText = "VD";

    if (cartData.course_lessons) {
      tags.push(
        `${cartData.course_lessons} Module${cartData.course_lessons > 1 ? "s" : ""}`,
      );
    }
    if (cartData.views && cartData.product_type != "course") {
      tags.push(`${cartData.views} View${cartData.views > 1 ? "s" : ""}`);
    }
    if (cartData.lessons) {
      tags.push(`${cartData.lessons} Module${cartData.lessons > 1 ? "s" : ""}`);
    }
    if (cartData.event_count) {
      tags.push(
        `${cartData.event_count} Event${cartData.event_count > 1 ? "s" : ""}`,
      );
    }

    if (cartData.delivery_mode) {
      tags.push(getSessionType(cartData.delivery_mode));
    }

    if (cartData.host_name) tags.push(cartData.host_name);
  }
  if (cartData.duration) {
    let duration = convertMinutesToHoursAndMinutes(cartData.duration);
    if (cartData.durationUnit === "seconds") {
      duration = convertTimeFormat(cartData.duration, true);
    }
    tags.push(duration);
  }
  console.log("tagsarr", tags);
  let priceInfo = getProcureInfo(cartData.purchase_info);
  cartData.priceInfo = priceInfo;
  return {
    id: cartData.product_id,
    title: cartData.product_name,
    logoURL: logoURL,
    logoAltText: "",
    bannerURL: cartData.product_thumbnail,
    tagsArray: tags,
    description: "",
    duration: "",
    showHeader: true,
    showProviderIcon: true,
    showPlayButton: false,
    showProgress: false,
    showBody: false,
    showFooter: true,
    btnTitle: btnTitle,
    btnAction: navigateToView(cartData),
    descAction: navigateToView(cartData),
    bannerAction: navigateToView(cartData),
    cardClassName: "cart-product-card",
    footerLineComp: "",
    isLoading: false,
    view: cartData.views,
    // price: cartData.product_sale_price,
    price: ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor),
    priceInfo: priceInfo,
    rightBtnIcon: "",
    lefttBtnIcon: "",
    isBundle: _.toLower(cartData?.sfdc_product_type) === "bundle",
    bundles: !_.isEmpty(cartData.course_list)
      ? _.map(cartData.course_list, (entity) => {
          return { thumbnail: entity.imageURL };
        })
      : [],
    productType: cartData?.product_type,
    productQty: cartData?.product_qty,
    crscd: cartData?.course_code,
    source: cartData?.source,
    isMobile: cartData?.isMobile,
    service_code:
      cartData?.product_type === "service" ? cartData?.service_code : "",
    eventId: cartData?.product_type === "certificate" ? cartData?.eventId : "",
    eventCode:
      cartData?.product_type === "certificate" ? cartData?.event_code : "",
    entityId:
      cartData?.product_type === "learningpath"
        ? cartData?.product_ecom_id
        : "",
  };
};

export const getEntityType = (type) => {
  switch (type) {
    case "event":
      return "Event";
    case "course":
      return "Course";
    case "video":
      return "Video";
    case "level":
      return "Level";
    case "learningpath":
      return "Action Path";
    case "bundle":
      return "Combo";
    case "roleplay":
      return "Role play";
    case "certificate":
      return "Certifications";
    case "session":
      return "Session";
    default:
      return "";
      break;
  }
};

// ob_lp = 0(lp),1(my-lp),2(my-ob)
export const goToLPDetailUtil = (
  lpInfo,
  navigate,
  ob_lp = 0,
  shareClick,
  isMobile = false,
) => {
  if (shareClick === "share") {
    localStorage.setItem(SessionKeys.URL_COPIED, "c");
  }
  if (isMobile) {
    let obj = {
      type: "learningpath",
      obj: lpInfo,
      method: "navigate-to-detail-page",
    };
    // if(lpInfo?.product_type === "bundle") {
    //     obj.via = "lp";
    // } else {
    //     obj.ob_lp_flag = ob_lp;
    //     obj.is_level = "false";
    // }
    if (window.callbackHandler != undefined) {
      window.callbackHandler.postMessage(JSON.stringify(obj));
    } else if (window.webkit != undefined) {
      if (window.webkit.messageHandlers.callbackHandler != undefined) {
        window.webkit.messageHandlers.callbackHandler.postMessage(
          JSON.stringify(obj),
        );
      }
    }
    return;
  }
  if (lpInfo?.product_type === "bundle") {
    let paramsReq = {
      lp_id: lpInfo.id,
      source: lpInfo?.origin,
      via: "lp",
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    navigate(`/bundleDetail?c=${encodedUrl}`);
  } else {
    // if (lpInfo?.crs_status === "over-due" || lpInfo?.crs_status === "overdue" || lpInfo?.status === "over-due" || lpInfo?.status === "overdue") {
    //   return;
    // }
    let paramsReq = {
      lp_id: lpInfo.id,
      is_level: "false",
      source: lpInfo?.origin,
      ob_lp_flag: ob_lp,
    };
    if (lpInfo.provider_id) {
      paramsReq.provider_id = lpInfo.provider_id;
      paramsReq.provider_name = lpInfo.provider_name
        ? lpInfo.provider_name
        : "";
    }
    if (lpInfo?.is_home) {
      paramsReq.is_home = true;
    }
    if (lpInfo?.fromSub) {
      paramsReq.from_sub = true;
    }

    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);

    clickStreamUser(
      "actionpath-detail-navigation",
      {
        url: `/lpDetail?c=${encodedUrl}`,
        fromPage: window.location.pathname + "" + window.location.search,
      },
      {},
    );

    const fullUrl = window.location.origin + `/lpDetail?c=${encodedUrl}`;

    if (localStorage.getItem(SessionKeys.URL_COPIED) === "c") {
      localStorage.removeItem(SessionKeys.URL_COPIED);
      navigator.clipboard
        .writeText(fullUrl)
        .then(() => {
          console.log("URL copied to clipboard:", fullUrl);
          const componentKey = sessionStorage.getItem("shareComponentKey");
          console.log("Dispatching urlCopied event with componentKey:", componentKey);
          // dispatch(setIsLoadingGlobal(false));
          const event = new CustomEvent("urlCopied", {
            detail: { componentKey },
          });
          window.dispatchEvent(event);
          sessionStorage.removeItem("shareComponentKey");
        })
        .catch((err) => {
          console.error("Failed to copy URL:", err);
          // dispatch(setIsLoadingGlobal(false));
        });
    } else {
      navigate(`/lpDetail?c=${encodedUrl}`);
    }
  }
};

export const getTimeDiff = (start) => {
  let startTime = moment(start * 1000);
  let nowTime = moment();
  var duration = moment.duration(nowTime.diff(startTime));
  var hours = duration.asHours();
  console.log("Duration: ", hours, start);
  if (hours <= 1440) {
    return true;
  } else {
    return false;
  }
};

export const getFormatedDataOfLPUtils = (
  learning,
  dispatch,
  currentCourseName = "",
) => {
  let sendFlag = false;
  console.log("lpDetail: ", learning);

  if (learning.coursesList) {
    learning.is_manager_checklist = false;
    for (let [index, course] of learning.coursesList.entries()) {
      let currentCourse = course;
      let nextCourse = learning.coursesList[index + 1];
      console.log("CURRENT COURSE", currentCourse);
      console.log("NEXT COURSE", nextCourse);
      if (learning.sequence === 1) {
        console.log("is sequence");
        if (index === 0) {
          currentCourse.isLock = false;
        }
        currentCourse.isLock =
          currentCourse.isLock === false ? currentCourse.isLock : true;
        if (currentCourse.crs_progress > 0) {
          console.log("CURRENT PROGRESS IS MORE THAN ZERO");
          // currentCourse.isLock = currentCourse.crs_progress >= 100 ? false;
          if (index !== learning.coursesList.length - 1) {
            console.log("INDEX IS NOT LAST");
            nextCourse.isLock =
              _.toNumber(currentCourse.crs_progress) >= 100 &&
              !currentCourse.isLock
                ? false
                : true;
            if (
              !_.isEmpty(currentCourseName) &&
              currentCourse.name === currentCourseName
            ) {
              nextCourse.isLock = false;
            }
            console.log("NEXT COURSE ISLOCK", nextCourse.isLock);
          }
        }
      } else {
        currentCourse.isLock = currentCourse.isLock
          ? currentCourse.isLock
          : false;
      }
      currentCourse.duration =
        currentCourse.entity_type === "video"
          ? convertTimeFormat(_.toNumber(currentCourse.duration), true)
          : convertTimeFormat(_.toNumber(currentCourse.duration));
      currentCourse.durationUnit = "";
      // console.log("detaiiii", course)

      // will uncomment this when checklist is available in B2C
      if (index < learning.coursesList.length - 1) {
        if (
          !currentCourse?.is_checklist_approved &&
          currentCourse?.is_checklist_present
        ) {
          nextCourse.isLock = nextCourse.crs_progress <= 100 ? true : false;
        } else if (
          currentCourse?.is_checklist_approved &&
          currentCourse?.is_checklist_present
        ) {
          nextCourse.isLock = false;
        }

        if (currentCourse.is_checklist_present) {
          learning.is_manager_checklist = true;
        }
      }

      if (
        !currentCourse?.is_checklist_approved &&
        currentCourse?.is_checklist_present &&
        !sendFlag
      ) {
        if (
          currentCourse.crs_progress >= 100 &&
          !currentCourse.isLock &&
          index !== learning.coursesList.length - 1
        ) {
          dispatch(
            getCheckListInsert({
              module: "checklist-insert",
              postData: {
                token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                lp_id: learning?.id,
                entity_id:
                  currentCourse.source === "broker"
                    ? currentCourse.id
                    : currentCourse?.crscd,
                entity_type: !currentCourse?.is_level
                  ? currentCourse.entity_type
                  : "level",
              },
            }),
          );
          sendFlag = true;
        }
      }
    }
    for (let course of learning.coursesList) {
      course.is_manager_checklist = learning.is_manager_checklist;
    }

    let priceInfo = getProcureInfo(learning.purchased_info);
    priceInfo.isAddToCart = learning.is_addtocart;
    console.log("PRICE INFO", priceInfo);
    let tags = [];
    let logoURL = "";
    if (!_.isEmpty(learning.provider)) {
      tags.push(learning.provider.provider_display_name);
      logoURL = learning.provider.provider_img;
    }
    tags.push("Action Path");
    if (learning.provider?.provider_display_name) {
      tags.push(learning.provider.provider_display_name);
    }
    tags.push(getEntityType(learning.entity_type));

    if (learning.entity_type === "course" && learning.lessons) {
      tags.push(`${learning.lessons} Module${learning.lessons > 1 ? "s" : ""}`);
    } else if (learning.entity_type === "level") {
      if (learning.course_count > 0)
        tags.push(
          `${learning.course_count} Course${learning.course_count > 1 ? "s" : ""}`,
        );
      else if (learning.video_count > 0)
        tags.push(
          `${learning.video_count} Video${learning.video_count > 1 ? "s" : ""}`,
        );
      else if (learning.event_count > 0)
        tags.push(
          `${learning.event_count} Event${learning.event_count > 1 ? "s" : ""}`,
        );
    }
  }

  return learning;
};

export const capitalizeFirstLetter = (string) => {
  return string?.charAt(0)?.toUpperCase() + string?.slice(1);
};

export const getSessionType = (type) => {
  switch (type) {
    case "face_to_face":
      return "In-Person";
    case "blended_session":
      return "In-Person / Virtual";
    case "virtual_broadcast":
      return "Virtual";
    case "virtual_interactive":
      return "Virtual";
    default:
      return "Live";
  }
};

export const getFileTypeName = (file_type) => {
  switch (file_type.toLowerCase()) {
    case "mp4":
      return "Video";
    case "pdf":
      return "PDF";
    case "scorm":
      return "Self Study";
    case "url":
      return "Self Study";
    case "zip":
      return "Self Study";
    default:
      return "Self Study";
  }
};

export const encryptPassword = (password) => {
  return CryptoJS.AES.encrypt(password, CONFIG.SECRET_KEY).toString();
};

export const decryptPassword = (encryptedPassword) => {
  const bytes = CryptoJS.AES.decrypt(encryptedPassword, CONFIG.SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const checkRankStatusFunc = (dispatch, getRankStatus) => {
  dispatch(
    getRankStatus({
      module: "getRankStatus",
      postData: {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      },
    }),
  );
};

export const commonApiReqDel = (moduleName, dispatch, requestFunc, reqObj) => {
  dispatch(
    requestFunc({
      module: moduleName,
      postData: reqObj,
    }),
  );
};

export const formatDate = (dateStr) => {
  const dateObj = new Date(dateStr);
  const options = { year: "numeric", month: "short", day: "numeric" };
  return dateObj.toLocaleDateString("en-US", options);
};

export const dateTimeStamp = (stamp) => {
  const formattedDate = moment
    .tz(stamp, "YYYY-MM-DD HH:mm:ss", "UTC") // Parse as UTC
    .tz("America/New_York") // Convert to EST
    .format("D MMM YYYY, HH:mm:ss");
  return formattedDate;
};

export const getTimeStampWithAbbr = (timeStamp, abbr) => {
  const convertedMoment = moment(timeStamp).format("MM/DD/YYYY hh:mm a");
  const con = moment.utc(convertedMoment).tz(abbr).format("MM/DD/YYYY hh:mm a");

  return moment(con, "MM/DD/YYYY hh:mm a").valueOf();
};

export const addHourAndSetTime = (timeString, hour) => {
  // Parse the input time string (format: "HH:mm")

  const [hours, minutes] = timeString.split(":").map(Number);
  console.log("timeString", hours, minutes);
  // Create a Date object and add 1 hour
  const date = new Date();

  if (
    (hours === 23 && hour === 1) ||
    (hours >= 20 && hour === 4) ||
    (hours >= 16 && hour === 8)
  ) {
    if (hour === 4 || hour === 8) {
      date.setHours(23, 59);
    } else {
      date.setHours(hours, 59);
    }
  } else {
    date.setHours(hours + hour, minutes);
  }

  // Format the time back to "HH:mm" for input type="time"
  const formattedTime = date.toTimeString().slice(0, 5);

  return formattedTime;
};

export const scrollIntoViewWithOffset = (selector, offset) => {
  const element = document.querySelector(selector);
  console.log(element);
  if (element) {
    const rect = element.getBoundingClientRect();
    const bodyRect = document.body.getBoundingClientRect();
    console.log({
      behavior: "smooth",
      top: rect.top - bodyRect.top - offset,
    });
    window.scrollTo({
      behavior: "smooth",
      top: rect.top - bodyRect.top - offset,
    });
  }
};

export const convertToEmoji = (text) => {
  return text
    .replace(/:\)/g, "😊") // Replace :) with 😊
    .replace(/;\)/g, "😉") // Replace ;) with 😉
    .replace(/:D/g, "😄") // Replace :D with 😄
    .replace(/:P/g, "😜") // Replace :P with 😜
    .replace(/:\(/g, "☹️") // Replace :( with ☹️
    .replace(/<3/g, "❤️") // Replace <3 with ❤️
    .replace(/:O/g, "😮") // Replace :O with 😮
    .replace(/:o/g, "😲") // Replace :o with 😲
    .replace(/XD/g, "😂") // Replace XD with 😂
    .replace(/B\)/g, "😎") // Replace B) with 😎
    .replace(/:\/\//g, "😕") // Replace :// with 😕
    .replace(/:\|/g, "😐") // Replace :| with 😐
    .replace(/:S/g, "😖") // Replace :S with 😖
    .replace(/:A/g, "😇") // Replace :A with 😇
    .replace(/:v/g, "🖖") // Replace :v with 🖖
    .replace(/:-\)/g, "😊") // Replace :-) with 😊
    .replace(/;-D/g, "😉") // Replace ;-) with 😉
    .replace(/:-D/g, "😄") // Replace :-D with 😄
    .replace(/<\\3/g, "💔") // Replace <\3 with 💔
    .replace(/:star:/g, "⭐"); // Replace :star: with ⭐
};

export const getTimeTense = (current, start, end) => {
  console.log(
    "current",
    current,
    start,
    end,
    moment(current).format("YYYY-MM-DD HH:mm:ss"),
    moment(end).format("YYYY-MM-DD HH:mm:ss"),
  );

  let result;
  if (current.isBefore(start)) {
    result = "future";
  } else if (current.isAfter(end)) {
    result = "past";
  } else {
    result = "present";
  }
  return result;
};

const controllers = new Set();

export const createAbortController = () => {
  const controller = new AbortController();
  controllers.add(controller);
  return controller;
};

export const abortAllRequests = () => {
  controllers.forEach((controller) => controller.abort());
  controllers.clear();
};

export const showTourAndGuideUtils = (dispatch) => {
  // sessionStorage.setItem(SessionKeys.IS_TOUR, "YES");
  // if (document.getElementById("idForTour") !== null) {
  //   document.getElementById("idForTour").classList.add("taketour");
  // }

  dispatch(
    setJoyRideReq({
      run: true,
      stepIndex: 0,
    }),
  );
};

export const ActivityRing = ({
  value,
  pathColor,
  trailColor,
  size,
  margin,
}) => (
  <div
    style={{
      position: "absolute",
      width: size,
      height: size,
      marginTop: margin,
      marginLeft: margin,
    }}
  >
    <CircularProgressbar
      value={value}
      strokeWidth={16}
      styles={buildStyles({
        pathColor,
        trailColor,
        strokeLinecap: "round",
        rotation: 0.25, // starts at top-right
      })}
    />
  </div>
);

export const rings = [
  {
    value: 0,
    pathColor: "#27897E",
    trailColor: "#D4EBE9",
    stroke: 16,
    size: 110,
    margin: 0,
  },
  {
    value: 0,
    pathColor: "#2684E8",
    trailColor: "#B3DCF9",
    stroke: 16,
    size: 70,
    margin: 20,
  },
  {
    value: 0,
    pathColor: "#B056F6 ",
    trailColor: "#DCB4FC",
    size: 42,
    stroke: 16,
    margin: 34,
  },
];

export const getAssetType = (asset_type) => {
  let type = "";
  switch (asset_type?.toLowerCase()) {
    case "article":
      type = "Article";
      break;
    case "scorm":
      type = "Assessment";
      break;
    case "mp3":
      type = "Audio";
      break;
    case "files":
      type = "Calculator";
      break;
    case "pdf":
    case "mp4":
      type = "Video";
      break;
    default:
      type = asset_type;
      break;
  }
  return type;
};

export const assetTypes = [
  {
    id: "1",
    name: "Article",
  },
  {
    id: "2",
    name: "Assessment",
  },
  {
    id: "3",
    name: "Audio",
  },
  {
    id: "4",
    name: "Calculator",
  },
  {
    id: "5",
    name: "Course",
  },
  {
    id: "6",
    name: "Money Metrics",
  },
  {
    id: "7",
    name: "Resource",
  },
  {
    id: "8",
    name: "Video",
  },
  {
    id: "9",
    name: "Webinar",
  },
  {
    id: "10",
    name: "Action Path",
  },
];

export const getAssetButtonName = (asset_id) => {
  const asset = assetTypes.find((item) => item.id === String(asset_id));
  return asset ? _.toLower(asset.name) : "money compass";
};

export const scheduleSessionApiCall = () => {
  const payload = {
    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
  };

  const url = `${CONFIG.API_URL_BROKER_ADMIN}/wp-json/xsel/v1/schedule-user-session`;
  clickStreamUser("schedule-session-api-call", { url: url }, {});
  return axios
    .post(url, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // Optionally handle error here
      throw error;
    });
};

export const showLeftSession = () => {
  if (
    window.location.pathname?.includes("explore") ||
    window.location.pathname?.includes("calc") ||
    window.location.pathname?.includes("money-metric") ||
    window.location.pathname?.includes("assess")
  ) {
    return true;
  } else {
    return false;
  }
};

export const truncateText = (text, maxLength = 7) => {
  if (!text) return "";
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
};

export const isEllipses = (text, maxLength = 7) => {
  if (!text) return false;
  return text.length > maxLength ? true : false;
};

export const markModuleProgressUtils = (
  dispatch,
  mId,
  cId,
  source,
  type,
  from,
  via_lp,
  lp_id,
) => {
  let reqBody = {
    module_id: mId,
    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
    course_id: cId,
    source: source === "broker" ? "broker" : "xsel",
    type: _.toLower(type),
  };

  if (from === "lp" || via_lp === "true") {
    reqBody.lp_id = lp_id;
  }

  dispatch(
    markModuleProgress({
      module: "markModuleProgress",
      postData: reqBody,
    }),
  );
};

export const redirectToAuthUrl = (isBackdoor, sd, loginType) => {
  if (isBackdoor === "1" || sd === "1" || loginType === 1) {
    return;
  }

  if (window.location.origin.includes("financialwellness")) {
    window.open(
      "https://financialwellness-auth.envision.pwc.com/saml/authn_request.jsp",
      "_self",
    );
  } else {
    window.open("https://finwell-auth-demo.training.com", "_self");
  }
};

export const cookieUpdateToServer = (email) => {
  // SENT USER DETAIL AFTER ACCEPT / REJECT COOKIE CONSENT
  let cc_cookie_raw = Cookies.get("cc_cookie");
  if (!cc_cookie_raw) {
    console.error("Cookie consent not found");
    return;
  }
  const cc_cookie = JSON.parse(cc_cookie_raw);

  cc_cookie.data = {
    username: email,
    App: "PROJECT_CODE",
  };
  console.log("Cookie consent data:", cc_cookie);
  const full_url =
    "https://events.niit-mts.com/cookieconcent/metadata?data=" +
    encodeURIComponent(JSON.stringify(cc_cookie));

  axios
    .get(full_url)
    .then((response) => {})
    .catch((error) => {
      console.error("Consent metadata error:", error);
    });
};

export const startSession = () => {
  const now = new Date().getTime();
  localStorage.setItem("sessionStart", now.toString());
};

export const isSessionExpired = () => {
  // If you need to access Redux state here, you must import the store and use store.getState():
  // import store from '../redux/store';
  const authBroker = store.getState().auth.authBroker;
  if (!authBroker || !authBroker.payload || !authBroker.payload.user) {
    return false; // If authBroker is not available, consider the session expired
  }
  console.log("authBroker11111", authBroker);
  const sessionStart = localStorage.getItem("sessionStart");
  const now = new Date().getTime();

  if (!sessionStart) return false;

  const hoursPassed = (now - parseInt(sessionStart)) / (1000 * 60 * 60); // convert ms to hours
  let hoursLimit = authBroker?.payload?.user?.session_hour || 12; // default to 12 hours if not set in Redux state
  console.log(
    "hoursPassed ",
    hoursLimit,
    authBroker?.payload?.user?.session_hour,
  );
  return hoursPassed > hoursLimit;
};

export const expireLogout = () => {
  setTimeout(() => {
    axios
      .post(CONFIG.API_URL_REAL_BROKER + "wp-json/broker/logout", {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        impersonate: 0,
      })
      .then((response) => {
        alert("Your Session is expired. Please Sign in again.");
        window.alert = () => false;
        localStorage.clear();
        window.open(API_LIST.SESSION_EXPIRED_URL + "/logout", "_self");
        // alert("Session is expired.")
        navigate("/logout", { sessionExpired: true });
      })
      .catch((error) => {});
  }, 3000);
};

export const convertToObjects = (arr) => {
  return arr.map((item) => {
    const [quesPart, responsePart] = item.split("| Response:");
    return {
      ques: quesPart.trim(),
      response: responsePart ? responsePart.trim() : "",
    };
  });
};

export const setFavicon = (favUrl) => {
  //  document.title = window.location.origin.includes("pwc") || window.location.origin.includes("localhost")?"PWC":"Xsel";

  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = favUrl;
};

export const getCurrentLocationPath = (location) => {
  const domainArray = window.location.host.split(".");
  const subDomain = isProd()
    ? domainArray[0] + "." + domainArray[1]
    : domainArray[0];
  localStorage.setItem(SessionKeys.LOGIN_COMPANY, subDomain);
  const locationPath = {
    path: location.pathname,
    query: location.search,
    company: subDomain,
  };
  localStorage.setItem(
    SessionKeys.LOCATION_PATH_REDIRECT,
    JSON.stringify(locationPath),
  );

  return locationPath;
};

export const setCurrentLocationPath = () => {
  const domainArray = window.location.host.split(".");
  const subDomain = isProd()
    ? domainArray[0] + "." + domainArray[1]
    : domainArray[0];

  const locationPath = {
    path: window.location.pathname,
    query: window.location.search,
    company: subDomain,
  };
  localStorage.setItem(
    SessionKeys.LOCATION_PATH_REDIRECT,
    JSON.stringify(locationPath),
  );
};

export const isProd = () => {
  if (
    window.location.origin.includes("stg") ||
    window.location.origin.includes("uat") ||
    window.location.origin.includes("demo") ||
    window.location.origin.includes("dev") ||
    window.location.origin.includes("local")
  ) {
    return false;
  } else {
    return true;
  }
};

export const formatMinutes = (mins) => {
  const duration = moment.duration(mins, "minutes");

  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  return `${hours} hour${hours !== 1 ? "s" : ""} ${minutes} minute${minutes !== 1 ? "s" : ""}`; // ${seconds} second${seconds !== 1 ? 's' : ''}
};

export const getBrokerInfo = (dispatch) => {
  const domainArray = window.location.host.split(".");
  let subDomain = "";

  if (!domainArray[0].includes("localhost")) {
    //domainArray[0] !== CONFIG.SUB_DOMAIN_NAME &&
    subDomain = isProd()
      ? domainArray[0] + "." + domainArray[1]
      : domainArray[0];
    dispatch(
      getLoginLogo({
        URL: `${CONFIG.API_URL_BROKER_ADMIN}${API_LIST.BROKER_API.LOGIN_LOGO_URL}`,
        payload: {
          company_ref: subDomain,
          // email: localStorage.getItem('redirect_email')
        },
        isJSON: true,
        method: "post",
      }),
    );
  }
};
